function BasicEvent(type)
{
	this.type = type;
	
	this.target = undefined;
}

export default BasicEvent;
